<template>
  <vue-phone-number-input ref="phoneInput" :disabled="disabled" @input="updatePhoneNumber" v-model="value" v-bind="plugin.props" :fetchCountry="!editMode" :noUseBrowserLocale="editMode"/>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
  name: 'VuePhone',
  props: {
    phone: {
      type: String,
      default: ''
    },
    editMode: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VuePhoneNumberInput
  },
  data () {
    return {
      defaultValueHasSet: false,
      value: '',
      plugin: {
        props: {
          noFlags: false,
          error: false,
          borderRadius: 20,
          clearable: true,
          preferredCountries: ['ZA'],
          noExample: false,
          noValidatorState: false,
          translations: {
            countrySelectorLabel: 'Country code',
            countrySelectorError: 'Invalid Country',
            phoneNumberLabel: 'Enter your phone number',
            example: 'Example: '
          }
        }
      },
    }
  },
  methods: {
    updatePhoneNumber () {
      let formattedValue = this.$refs.phoneInput.phoneFormatted
      if (typeof formattedValue !== 'undefined' && formattedValue.length > 0) {
        formattedValue = formattedValue.replace(/[\s\+]/g, '')
      } else {
        formattedValue = ''
      }
      this.defaultValueHasSet = true
      this.$emit('update:phone', formattedValue)
    },
  },
  watch: {
    phone (val) {
      //We need to set the default value only once. We are doing this way because country flag does not update on mobile number update
      if (this.editMode && !this.defaultValueHasSet && val !== this.value) {
        this.defaultValueHasSet = true

        if (!val.startsWith('+')) {
          val = '+' + val
        }
        this.value = val
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VuePhone.vue